import React, { useState } from 'react';

//https://us-central1-pika-jessica.cloudfunctions.net/api/items

function Home() {
    const [isDarkTheme, setIsDarkTheme] = useState(false);
    const [language, setLanguage] = useState('en'); // Default language is English

    const toggleTheme = () => {
        setIsDarkTheme(!isDarkTheme);
    };

    const toggleLanguage = () => {
        setLanguage(language === 'en' ? 'ko' : 'en');
    };

    const themeStyles = {
        backgroundColor: isDarkTheme ? '#121212' : '#f9f9f9',
        color: isDarkTheme ? '#ffffff' : '#333',
        transition: 'background-color 0.3s, color 0.3s',
        minHeight: '100vh',
        fontFamily: 'Arial, sans-serif',
        lineHeight: '1.6',
    };

    const headerStyles = {
        backgroundColor: isDarkTheme ? '#1f1f1f' : '#007BFF',
        color: '#ffffff',
        padding: '20px',
        textAlign: 'center',
    };

    const sectionStyles = {
        textAlign: 'left',
        maxWidth: '1000px',
        margin: '20px auto',
        backgroundColor: isDarkTheme ? '#1e1e1e' : '#ffffff',
        color: isDarkTheme ? '#e0e0e0' : '#333',
        padding: '20px',
        borderRadius: '8px',
        boxShadow: isDarkTheme ? '0 4px 10px rgba(0, 0, 0, 0.5)' : '0 4px 10px rgba(0, 0, 0, 0.1)',
    };

    const footerStyles = {
        marginTop: '20px',
        color: isDarkTheme ? '#888' : '#666',
        textAlign: 'center',
        padding: '10px 0',
    };

    const buttonStyles = {
        backgroundColor: isDarkTheme ? '#007BFF' : '#333',
        color: '#ffffff',
        border: 'none',
        padding: '10px 15px',
        cursor: 'pointer',
        borderRadius: '5px',
        position: 'absolute',
        top: '10px',
        right: '0px',
        transition: 'background-color 0.3s',
    };

    const languageButtonStyles = {
        ...buttonStyles,
        right: '20px', // Adjust position for language button
    };

    const content = {
        en: {
            title: 'Privacy Policy & Terms of Use',
            privacyPolicy: `
1. Information We Collect:
   - We collect personal information such as name, email, and usage data to improve the service.

2. How We Use Your Information:
   - Your information is used for creating videos, enhancing user experience, and improving app performance.

3. Data Sharing:
   - We do not sell or share your personal information with third parties except as necessary to provide the service.

4. Your Rights:
   - You have the right to access, modify, or delete your personal data.

5. Changes to This Policy:
   - This policy may be updated from time to time. Please review it regularly for any changes.
            `,
            termsOfUse: `
1. License Agreement:
   - You are granted a non-exclusive, non-transferable, limited license to use the app for personal, non-commercial purposes.

2. User Conduct:
   - You must not reverse-engineer, decompile, or modify any part of the app.

3. Intellectual Property:
   - All intellectual property rights in the app remain the property of the developers.
   - Content generated using the app remains your property.

4. Disclaimer:
   - The app is provided "as is" without any warranty.

5. Limitation of Liability:
   - The developers shall not be liable for damages arising out of or in connection with the use of the app.

6. Changes to the Terms:
   - Continued use of the app signifies your acceptance of the revised terms.

7. Contact:
   - For questions, contact pika.jessica777@gmail.com.
            `,
        },
        ko: {
            title: '개인정보 처리방침 & 이용 약관',
            privacyPolicy: `
1. 수집하는 정보:sdfds
   - 우리는 이름, 이메일, 사용 데이터를 수집하여 서비스를 개선합니다.

2. 정보 사용 방식:
   - 수집된 정보는 동영상 생성, 사용자 경험 향상 및 앱 성능 개선에 사용됩니다.

3. 데이터 공유:
   - 필요한 경우를 제외하고 귀하의 개인 정보를 제3자와 공유하거나 판매하지 않습니다.

4. 사용자 권리:
   - 귀하는 개인 데이터를 접근, 수정 또는 삭제할 권리가 있습니다.

5. 정책 변경:
   - 이 정책은 주기적으로 업데이트될 수 있으니 정기적으로 확인하세요.
            `,
            termsOfUse: `
1. 라이선스 동의:
   - 개인 용도로 제한적 라이선스가 부여됩니다.

2. 사용자 행동:
   - 앱을 역설계, 디컴파일 또는 수정해서는 안 됩니다.

3. 지적 재산권:
   - 모든 지적 재산권은 개발자에게 있으며, 생성된 콘텐츠의 저작권 준수는 사용자 책임입니다.

4. 면책 조항:
   - 이 앱은 "있는 그대로" 제공되며, 어떠한 보증도 제공되지 않습니다.

5. 책임 제한:
   - 개발자는 앱 사용으로 인한 손해에 대해 책임을 지지 않습니다.

6. 약관 변경:
   - 앱 사용 지속은 약관 변경에 대한 동의를 의미합니다.

7. 문의:
   - 문의 사항은 pika.jessica777@gmail.com으로 연락하세요.
            `,
        },
    };

    return (
        <div style={themeStyles}>
            <button style={languageButtonStyles} onClick={toggleLanguage}>
                {language === 'en' ? 'Korean' : 'English'}
            </button>
            <header style={headerStyles}>
                <h1>AI FlashScene Maker&nbsp;:    {content[language].title}</h1>
            </header>
            <section style={sectionStyles}>
                <h2>Privacy Policy</h2>
                <pre>{content[language].privacyPolicy}</pre>
                <h2>Terms of Use (EULA)</h2>
                <pre>{content[language].termsOfUse}</pre>
            </section>
            <footer style={footerStyles}>
                <p>&copy; 2024 JessicaLabs. All rights reserved.</p>
            </footer>
        </div>
    );
}

export default Home;
